<template>
  <base-dialog
    :action="onAction"
    :action-name="'Update customer'"
    :close="onClose"
    :title="'Update customer'"
  >
    <template #activator="{ on }">
      <slot
        name="activator"
        v-bind="{ on }"
      />
    </template>

    <template #content>
      <v-container>
        <v-row>
          <v-col cols="12">

            <v-text-field
              dense
              outlined
              v-model="model.name"
              label="Name"
            />

            <v-text-field
              dense
              outlined
              v-model="model.email"
              label="Email"
            />

            <v-text-field
              dense
              outlined
              v-model="model.phone"
              label="Phone"
            />

            <v-text-field
              dense
              outlined
              v-model="model.description"
              label="Description"
            />

            <v-select
              dense
              outlined
              v-model="model.tax_exempt"
              :items="[ 'none', 'exempt' ]"
              label="Tax Status (Exception)"
            />

            <v-select
              dense
              outlined
              v-model="model.preferred_locales"
              label="Preferred Languages"
              multiple
              :items="[ 'en', 'fr' ]"
            />

            <v-expansion-panels
              v-model="showBillingDetails"
              flat
              focusable
            >
              <v-expansion-panel>
                <v-expansion-panel-header class="mb-3">Billing Details</v-expansion-panel-header>
                <v-expansion-panel-content>

                  <v-text-field
                    dense
                    outlined
                    v-model="modelAddress.line1"
                    label="Address"
                  />

                  <v-text-field
                    dense
                    outlined
                    v-model="modelAddress.line2"
                    label="Address Line 2"
                  />

                  <v-text-field
                    dense
                    outlined
                    v-model="modelAddress.city"
                    label="City"
                  />

                  <v-text-field
                    dense
                    outlined
                    v-model="modelAddress.state"
                    label="Province / State"
                  />

                  <v-text-field
                    dense
                    outlined
                    v-model="modelAddress.postal_code"
                    label="Postal Code / ZIP"
                  />

                  <v-text-field
                    dense
                    outlined
                    v-model="modelAddress.country"
                    label="Country"
                  />

                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>

            <v-expansion-panels
              v-model="showShippingDetails"
              flat
              focusable
            >
              <v-expansion-panel>
                <v-expansion-panel-header class="mb-3">Shipping Details</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-text-field
                    dense
                    outlined
                    v-model="shippingName"
                    label="Name"
                  />
                  <v-text-field
                    dense
                    outlined
                    v-model="shippingPhone"
                    label="Phone"
                  />

                  <v-text-field
                    dense
                    outlined
                    v-model="shippingAddress.line1"
                    label="Address"
                  />

                  <v-text-field
                    dense
                    outlined
                    v-model="shippingAddress.line2"
                    label="Address Line 2"
                  />

                  <v-text-field
                    dense
                    outlined
                    v-model="shippingAddress.city"
                    label="City"
                  />

                  <v-text-field
                    dense
                    outlined
                    v-model="shippingAddress.state"
                    label="Province / State"
                  />

                  <v-text-field
                    dense
                    outlined
                    v-model="shippingAddress.postal_code"
                    label="Postal Code / ZIP"
                  />

                  <v-text-field
                    dense
                    outlined
                    v-model="shippingAddress.country"
                    label="Country"
                  />

                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>

          </v-col>
        </v-row>
      </v-container>
    </template>
  </base-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import BaseDialog from "../Common/BaseDialog"
import { get, isEmpty } from 'lodash'
import { isErrorResponse } from "../../services/util.service"

export default {
  components: { BaseDialog },
  props: {
    customer: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      model: {},
      modelAddress: {},
      shippingAddress: {},
      shippingName: null,
      shippingPhone: null,
      showBillingDetails: false,
      showShippingDetails: false
    }
  },
  watch: {
    customer() {
      this.model = { ...this.customer }
      this.modelAddress = this.customer.address ? { ...this.customer.address } : {}
      this.shippingAddress = { ...get(this.customer, 'shipping.address', {})}  || {}
      this.shippingName = get(this.customer, 'shipping.name', '') || ''
      this.shippingPhone = get(this.customer, 'shipping.phone', '') || ''
    }
  },
  methods: {
    ...mapActions([ 'updateCustomer' ]),
    _get: (val, path, def) => get(val, path, def),
    onClose() {
      this.$emit('close')
    },
    onAction() {
      const isShippingAddressEmpty = Object.values(this.shippingAddress).every(val => isEmpty(val))
      const isShippingNameEmpty = isEmpty(this.shippingName)
      const isShippingPhoneEmpty = isEmpty(this.shippingPhone)

      const isShippingEmpty = isShippingAddressEmpty
        && isShippingNameEmpty
        && isShippingPhoneEmpty

      const payload = {
        id: this.model.id,
        name: this.model.name,
        address: { ...this.modelAddress },
        email: this.model.email,
        phone: this.model.phone,
        description: this.model.description,
        tax_exempt: this.model.tax_exempt,
        preferred_locales: this.model.preferred_locales,
      }

      if (isShippingEmpty) {
        payload.shipping = null
      } else {
        payload.shipping = {
          address: { ...this.shippingAddress },
          name: this.shippingName,
          phone: this.shippingPhone
        }
      }

      return this.updateCustomer(payload)
        .then(customer => {
          if (!isErrorResponse(customer)) {
            this.$emit('action', customer)
          }
          return customer
        })
    }
  }
}
</script>
